import { SecondaryButton } from "@/components/buttons/SecondaryButton";
import AntIcon from "@/components/icons/AntIcon";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentAgentAccount } from "../../../../auth/hooks";
import { Contract } from "../../../types";
import { canSendContractToBackoffice, VERIFICATION_STATUSES_FOR_SENDING_TO_BACKOFFICE } from "../../../utils";
import ContractChangeVerificationStatusForm from "../../forms/ContractChangeVerificationStatusForm";

interface Props {
  contract: Contract;
  hasChangePermission: boolean;
}

export const ContractVerificationStatusButtonView = ({ contract, hasChangePermission }: Props) => {
  const { t } = useTranslation();

  const userAccount = useCurrentAgentAccount();
  const [statusFormOpen, setStatusFormOpen] = useState<boolean>(false);

  const canSendToBackoffice = useMemo(
    () => userAccount && canSendContractToBackoffice(userAccount, contract),
    [userAccount, contract],
  );

  if (hasChangePermission) {
    return (
      <>
        <SecondaryButton icon={<AntIcon type="reconciliation" />} onClick={() => setStatusFormOpen(true)}>
          {t("contract.actions.verificationStatusChange")}
        </SecondaryButton>

        <ContractChangeVerificationStatusForm
          open={statusFormOpen}
          contract={contract}
          onFormCancel={() => setStatusFormOpen(false)}
        />
      </>
    );
  } else if (
    canSendToBackoffice &&
    contract.verificationStatus &&
    VERIFICATION_STATUSES_FOR_SENDING_TO_BACKOFFICE.includes(contract.verificationStatus)
  ) {
    return (
      <>
        <SecondaryButton icon={<AntIcon type="file-done" />} onClick={() => setStatusFormOpen(true)}>
          {t("contract.actions.sendToBackoffice")}
        </SecondaryButton>

        <ContractChangeVerificationStatusForm
          open={statusFormOpen}
          contract={contract}
          viewType="sendToBackoffice"
          onFormCancel={() => setStatusFormOpen(false)}
        />
      </>
    );
  }

  return null;
};
